interface Props {
  total: number
  pageNum: number
  pageSize: number
  siblingCount: number
}

const range = (start: number, end: number) => {
  const length = end - start + 1
  return Array.from({ length }, (_, i) => start + i)
}

export const usePagination = ({ total, pageNum, pageSize, siblingCount }: Props) => {
  const totalPages = Math.ceil(total / pageSize) || 1
  const currentPage = pageNum > totalPages ? totalPages : pageNum

  const startPages = range(1, Math.min(1, totalPages))
  const endPages = range(Math.max(totalPages - 1 + 1, 1 + 1), totalPages)
  const siblingsStart = Math.max(
    Math.min(currentPage - siblingCount, totalPages - 1 - siblingCount * 2 - 1),
    1 + 2,
  )
  const siblingsEnd = Math.min(
    Math.max(currentPage + siblingCount, 1 + siblingCount * 2 + 1),
    endPages.length > 0 ? endPages[0] - 2 : totalPages - 1,
  )

  const itemList = [
    ...startPages,
    // Start ellipsis
    ...(siblingsStart > 1 + 2 ? ['ellipsis'] : 1 + 1 < totalPages - 1 ? [1 + 1] : []),
    // Sibling pages
    ...range(siblingsStart, siblingsEnd),
    // End ellipsis
    ...(siblingsEnd < totalPages - 1 - 1
      ? ['ellipsis']
      : totalPages - 1 > 1
        ? [totalPages - 1]
        : []),
    ...endPages,
  ] as (number | 'ellipsis')[]

  return { itemList }
}
